import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import '../../styles/PrelaunchPage.css';

const LAUNCH_DATE = new Date('2026-04-02T16:00:00-07:00');

function getTimeRemaining() {
  const now = new Date();
  const diff = LAUNCH_DATE - now;
  if (diff <= 0) return { hours: 0, minutes: 0, seconds: 0, expired: true };
  const totalSeconds = Math.floor(diff / 1000);
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    expired: false,
  };
}

function pad(n) {
  return String(n).padStart(2, '0');
}

const PrelaunchPage = ({ onShowLoginPopup, onShowSignUp, currentUser }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [time, setTime] = useState(getTimeRemaining);

  useEffect(() => {
    const id = setInterval(() => setTime(getTimeRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;
    if (!/^[^\s@]+@berkeley\.edu$/.test(trimmed)) {
      setError('Please use a @berkeley.edu email');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await addDoc(collection(db, 'prelaunchEmails'), {
        email: trimmed,
        createdAt: serverTimestamp(),
      });
      setSubmitted(true);
    } catch (err) {
      console.error('Error saving email:', err);
      setError('Something went wrong. Try again.');
    } finally {
      setSubmitting(false);
    }
  }, [email]);

  return (
    <div className="prelaunch-page">
      <Navbar
        onShowLoginPopup={onShowLoginPopup}
        onShowSignUp={onShowSignUp}
        currentUser={currentUser}
        isPrelaunch
      />

      <main className="prelaunch-main">
        <h1 className="prelaunch-title">WTF</h1>

        {submitted ? (
          <p className="prelaunch-thanks">You're on the list.</p>
        ) : (
          <form className="prelaunch-form" onSubmit={handleSubmit}>
            <div className="prelaunch-input-wrap">
              <input
                type="email"
                className="prelaunch-input"
                placeholder="email@berkeley.edu"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitting}
                autoComplete="email"
              />
              <button
                type="submit"
                className="prelaunch-submit"
                disabled={submitting}
                aria-label="Submit email"
              >
                ›
              </button>
            </div>
            {error && <p className="prelaunch-error">{error}</p>}
          </form>
        )}

        <p className="prelaunch-location">Sather Gate</p>
        <p className="prelaunch-date">April 2, 2026</p>

        <div className="prelaunch-countdown">
          <span className="prelaunch-countdown-digit">{pad(time.hours)}</span>
          <span className="prelaunch-countdown-sep">:</span>
          <span className="prelaunch-countdown-digit">{pad(time.minutes)}</span>
          <span className="prelaunch-countdown-sep">:</span>
          <span className="prelaunch-countdown-digit">{pad(time.seconds)}</span>
        </div>
      </main>

      <Footer
        onShowSignUp={onShowSignUp}
        currentUser={currentUser}
        isPrelaunch
        onEmailSubmitted={() => setSubmitted(true)}
      />
    </div>
  );
};

export default PrelaunchPage;
